import { Component, Input } from '@angular/core';

@Component({
  selector: 'side-panel-header',
  templateUrl: './side-panel-header.component.html',
  styleUrls: ['./side-panel-header.component.scss'],
})
export class SidePanelHeaderComponent {
  @Input() displayText = '';
  @Input() showBorder: boolean;
}
